import { color } from 'client/components/core/BaseEntity'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { useBackgroundImage } from 'client/hooks/useBackgroundImage'
import { useWebsiteSettings } from 'client/store'
import CommonSection from 'common/components/entities/Section'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import { commonWidthValues } from 'common/constants/commonWidth'
import React, { memo } from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/editor/store/website-settings/website-settings-selector'
import { convertContentWidthToCommonWidth } from 'src/shared/utils/convert-content-width-to-common-width'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

interface SectionProps {
  entity: SectionInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

const Section = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: SectionProps) => {
  const { backgroundImage, mobileBackgroundImage } = useBackgroundImage({
    backgroundFileId: entity.backgroundFileId,
    mobileBackgroundFileId: entity.mobileBackgroundFileId,
  })

  const websiteThemeBackground = useWebsiteSettings(getWebsiteThemeBackground)
  const pageBackgroundImage = getBackgroundImageStyleValue(
    websiteThemeBackground?.pageBackgroundPicture?.file,
  )
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  // NOTE: Make transparent background if page background image is set
  const backgroundColorFallback = pageBackgroundImage
    ? undefined
    : background?.pageBackgroundColor
  const containerBackgroundColorFallback =
    background?.contentBackgroundColor || background?.containerBackgroundColor

  const contentWidth =
    entity?.contentWidth ||
    (layout?.contentWidth &&
      convertContentWidthToCommonWidth(layout?.contentWidth))
  return (
    <BaseEntityNew
      entity={entity}
      highlightedColor={color.green}
      hoverColor={color.green}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonSection
        backgroundImage={backgroundImage}
        mobileBackgroundImage={mobileBackgroundImage}
        htmlAttrId={entity.htmlAttrId}
        backgroundColor={entity.backgroundColor || backgroundColorFallback}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        width={contentWidth && commonWidthValues[contentWidth]}
        containerBackgroundColor={
          entity.containerBackgroundColor || containerBackgroundColorFallback
        }
        mobileContainerBackgroundColor={entity.mobileContainerBackgroundColor}
        background={entity.background}
        mobileBackground={entity.mobileBackground}
      >
        <ChildrenEntities
          id={entity.id}
          childIds={entity.childIds}
          type={entity.type}
          isReadOnly={entity.isReadOnly}
        />
      </CommonSection>
    </BaseEntityNew>
  )
}

export default memo(Section)
